/* Olivia Sweetbites — montador de caixas
 * Lê os sabores (metaobjeto "sabor"), os tamanhos (variantes com custom.quantidade)
 * e a Olivia's Selection (variante custom.selecao_olivia). Regras:
 *  - cada sabor escolhido tem no mínimo 2 unidades
 *  - a soma fecha exatamente a caixa
 *  - sabores com "adicional" somam a variante de adicional por unidade
 */
(function () {
  function normalize(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }
  function fill(str, map) {
    return String(str).replace(/__(\w+)__/g, function (_, k) { return map[k] != null ? map[k] : ''; });
  }
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    var noDec = Math.round(cents / 100).toString();
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function init(root) {
    root.querySelectorAll('[data-box-builder]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';

      var i18n = {};
      try { i18n = JSON.parse(box.querySelector('[data-box-i18n]').textContent); } catch (e) {}
      var fmt = box.dataset.moneyFormat;
      var list = box.querySelector('[data-flavor-list]');
      var rows = Array.prototype.slice.call(box.querySelectorAll('[data-flavor]'));
      rows.sort(function (a, b) { return Number(a.dataset.order) - Number(b.dataset.order); });
      rows.forEach(function (r) { list.appendChild(r); });

      var sizes = Array.prototype.slice.call(box.querySelectorAll('[data-size]'));
      var addBtn = box.querySelector('[data-box-add]');
      var statusEl = box.querySelector('[data-box-status]');
      var errorEl = box.querySelector('[data-box-error]');
      var priceEl = document.querySelector('[data-price]');

      function current() {
        return sizes.find(function (b) { return b.getAttribute('aria-pressed') === 'true'; }) || sizes[0];
      }
      function mode() {
        var r = box.querySelector('.mode-choices input:checked');
        return r ? r.value : 'custom';
      }
      function qty(row) { return Number(row.querySelector('[data-qty]').value) || 0; }
      function setQty(row, n) { row.querySelector('[data-qty]').value = Math.max(0, n); }

      function selectionFor(size) {
        var cap = Number(size.dataset.capacity);
        var out = new Map();
        var text = size.dataset.selection || '';
        text.split(/\r?\n/).forEach(function (line) {
          var m = line.match(/^(.+?)\s*[:=x×-]\s*(\d+)\s*$/i);
          if (!m) return;
          var key = normalize(m[1]);
          var row = rows.find(function (r) { return normalize(r.dataset.name) === key || r.dataset.handle === key; });
          if (row) out.set(row, Number(m[2]));
        });
        var total = 0; out.forEach(function (v) { total += v; });
        if (out.size && total === cap) return out;
        // Sugestão automática: sabores sem adicional, distribuídos igualmente (mín. 2 cada).
        // Caixas de 50+ usam só números pares; a sobra vai sempre para o Tradicional ao Leite.
        out = new Map();
        var pool = rows.filter(function (r) { return !r.dataset.extraId; });
        if (!pool.length) pool = rows;
        var n = Math.max(1, Math.min(Math.floor(cap / 2), pool.length));
        var base = Math.floor(cap / n);
        if (cap >= 50 && base % 2) base -= 1;
        var chosen = pool.slice(0, n);
        chosen.forEach(function (r) { out.set(r, base); });
        var rest = cap - base * n;
        if (rest > 0) {
          var leite = rows.find(function (r) { return r.dataset.handle === 'tradicional-ao-leite'; }) || chosen[0];
          out.set(leite, (out.get(leite) || 0) + rest);
        }
        return out;
      }

      function applySelection() {
        var sel = selectionFor(current());
        rows.forEach(function (r) { setQty(r, sel.get(r) || 0); });
      }

      function state() {
        var size = current();
        var cap = Number(size.dataset.capacity);
        var sum = 0, valid = true, extraCents = 0;
        rows.forEach(function (r) {
          var q = qty(r);
          if (!Number.isInteger(q) || q < 0 || q === 1) valid = false;
          sum += q;
          if (q > 0 && r.dataset.extraCents) extraCents += q * Number(r.dataset.extraCents);
        });
        var available = size.dataset.available === 'true';
        return { size: size, cap: cap, sum: sum, valid: valid, available: available,
          total: Number(size.dataset.priceCents) + extraCents,
          ok: valid && sum === cap && available };
      }

      function update() {
        var s = state();
        box.querySelector('[data-box-count]').textContent = fill(i18n.count, { SUM: s.sum, CAP: s.cap });
        var p = box.querySelector('[data-box-progress]');
        p.max = s.cap; p.value = Math.min(s.sum, s.cap);
        var msg;
        if (!s.valid) msg = i18n.min2;
        else if (s.sum > s.cap) msg = fill(i18n.over, { N: s.sum - s.cap });
        else if (s.sum < s.cap) msg = fill(i18n.missing, { N: s.cap - s.sum });
        else msg = i18n.complete;
        statusEl.textContent = msg;
        statusEl.classList.toggle('is-ok', s.ok);
        box.querySelector('[data-box-total]').textContent = money(s.total, fmt);
        if (priceEl) priceEl.textContent = money(Number(s.size.dataset.priceCents), fmt);
        rows.forEach(function (r) {
          var q = qty(r);
          var plus = r.querySelector('[data-step="1"]');
          var room = s.cap - s.sum;
          plus.disabled = q === 0 ? room < 2 : room < 1;
          r.querySelector('[data-step="-1"]').disabled = q === 0;
          r.classList.toggle('is-active', q > 0);
        });
        addBtn.disabled = !s.ok;
        addBtn.textContent = s.available ? i18n.add : i18n.unavailable;
        errorEl.textContent = '';
      }

      box.addEventListener('click', function (e) {
        var step = e.target.closest('[data-step]');
        if (step) {
          var row = step.closest('[data-flavor]');
          var q = qty(row), d = Number(step.dataset.step);
          if (d > 0) setQty(row, q === 0 ? 2 : q + 1);
          else setQty(row, q <= 2 ? 0 : q - 1);
          update();
          return;
        }
        var size = e.target.closest('[data-size]');
        if (size && !size.disabled) {
          sizes.forEach(function (b) { b.setAttribute('aria-pressed', String(b === size)); });
          var url = new URL(location.href);
          url.searchParams.set('variant', size.dataset.variantId);
          history.replaceState({}, '', url);
          if (size.dataset.image) {
            document.querySelectorAll('[data-box-image]').forEach(function (img) {
              if (img.getAttribute('src') === size.dataset.image) return;
              img.classList.add('is-swapping');
              var pre = new Image();
              pre.onload = function () {
                img.src = size.dataset.image;
                if (size.dataset.imageAlt) img.alt = size.dataset.imageAlt;
                img.classList.remove('is-swapping');
              };
              pre.src = size.dataset.image;
            });
          }
          if (mode() === 'olivia') applySelection();
          else rows.forEach(function (r) { setQty(r, 0); });
          update();
        }
      });
      box.addEventListener('input', function (e) { if (e.target.matches('[data-qty]')) update(); });
      box.addEventListener('change', function (e) {
        if (e.target.matches('.mode-choices input')) {
          if (e.target.value === 'olivia') applySelection();
          else rows.forEach(function (r) { setQty(r, 0); });
        }
        if (e.target.matches('[data-qty]')) {
          var v = Math.floor(Number(e.target.value) || 0);
          e.target.value = Math.max(0, v);
        }
        update();
      });

      addBtn.addEventListener('click', function () {
        var s = state();
        if (!s.ok) { statusEl.focus(); return; }
        var boxId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        var chosen = rows.filter(function (r) { return qty(r) > 0; });
        var props = {};
        props[i18n.propMode] = mode() === 'olivia' ? i18n.modeOlivia : i18n.modeCustom;
        props[i18n.propFlavors] = chosen.map(function (r) { return qty(r) + '× ' + r.dataset.name; }).join(' · ');
        props._box_id = boxId;
        var items = [{ id: Number(s.size.dataset.variantId), quantity: 1, properties: props }];
        var extras = {};
        chosen.forEach(function (r) {
          if (!r.dataset.extraId) return;
          extras[r.dataset.extraId] = (extras[r.dataset.extraId] || 0) + qty(r);
        });
        Object.keys(extras).forEach(function (id) {
          var p = { _box_id: boxId };
          p[i18n.propBox] = s.cap + ' ' + i18n.units;
          items.push({ id: Number(id), quantity: extras[id], properties: p });
        });
        addBtn.disabled = true;
        addBtn.textContent = i18n.adding;
        fetch(box.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart');
          location.href = box.dataset.cartUrl;
        }).catch(function () {
          errorEl.textContent = i18n.error;
          update();
        });
      });

      applySelection();
      update();
      sizes.forEach(function (b) { if (b.dataset.image) { var p = new Image(); p.src = b.dataset.image; } });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
